import React from 'react';
import { Link } from 'react-router-dom';
import './Reservations.css';

const sections = [
  {
    to: '/backoffice/clientes',
    title: 'Clientes',
    description: 'Gestioná clientes y sus pasajeros.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  },
  {
    to: '/backoffice/fichas',
    title: 'Fichas de Reserva',
    description: 'Creá y seguí las fichas de reserva.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="8" y1="13" x2="16" y2="13" />
        <line x1="8" y1="17" x2="16" y2="17" />
      </svg>
    )
  },
  {
    to: '/backoffice/servicios',
    title: 'Servicios',
    description: 'Vuelos, hospedajes, asistencias y paquetes.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      </svg>
    )
  },
  {
    to: '/backoffice/operadores',
    title: 'Operadores',
    description: 'Administrá los operadores.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18" />
        <path d="M5 21V7l8-4v18" />
        <path d="M19 21V11l-6-4" />
        <line x1="9" y1="9" x2="9" y2="9.01" />
        <line x1="9" y1="12" x2="9" y2="12.01" />
        <line x1="9" y1="15" x2="9" y2="15.01" />
      </svg>
    )
  },
  {
    to: '/backoffice/gastos',
    title: 'Gastos',
    description: 'Registrá y controlá los gastos.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    )
  },
  {
    to: '/backoffice/rentabilidad',
    title: 'Rentabilidad',
    description: 'Analizá la rentabilidad del negocio.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="21" x2="21" y2="21" />
        <rect x="5" y="12" width="3" height="6" />
        <rect x="10.5" y="8" width="3" height="10" />
        <rect x="16" y="4" width="3" height="14" />
      </svg>
    )
  }
];

const HomePage = () => (
  <div className="page-wrapper backoffice-home">
    <header className="backoffice-hero">
      <span className="backoffice-eyebrow">BackOffice</span>
      <h1>Panel de gestión</h1>
      <p>Elegí una sección para comenzar a trabajar.</p>
    </header>

    <div className="backoffice-grid">
      {sections.map((section) => (
        <Link key={section.to} to={section.to} className="backoffice-card">
          <span className="backoffice-card-icon">{section.icon}</span>
          <span className="backoffice-card-body">
            <span className="backoffice-card-title">{section.title}</span>
            <span className="backoffice-card-desc">{section.description}</span>
          </span>
          <span className="backoffice-card-arrow" aria-hidden="true">→</span>
        </Link>
      ))}
    </div>
  </div>
);

export default HomePage;
